export const getTabTitle = (key) => {
  const titles = {
    all: "All Tasks",
    missed: "Missed Tasks",
    completed: "Task Done",
    approved: "Approved By Admin",
    rejected: "Rejected By Admin",
    pending: "In Progress",
    upcoming: "Upcoming Tasks",
    all_rejected: "All Rejected By Admin",
    re_submitted: "Re Submitted Tasks",
  };

  return (
    titles[key] ||
    key?.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())
  );
};

export const checkAllImagesVerified = (row, verifiedImages) => {
  const imgArrayLength = Number(row?.images_arr?.length || 0) > 0;
  if (!imgArrayLength) return true;
  return row?.images_arr?.every((img) => verifiedImages?.includes(img));
};

export const checkAllVideosVerified = (row, verifiedVideos) => {
  const vdoArrayLength = Number(row?.video_arr?.length || 0) > 0;
  if (!vdoArrayLength) return true;
  return row?.video_arr?.every((vid) => verifiedVideos?.includes(vid));
};

export const extractTimesFromArray = (timesArray) => {
  let start_end_time = [];

  timesArray?.length > 0 &&
    timesArray.forEach((item) => {
      const itemValue = item.value;
      start_end_time.push(itemValue);
    });

  return {
    start_end_time: start_end_time.join(", "),
  };
};
